// extracted by mini-css-extract-plugin
module.exports = {"Contato":"Contato_Contato__tjZCB"};